<template>
  <div class="brand-wrapper">
    <div class="fade left"></div>

    <div class="brand-bar">
      <div class="track">
        <div
          class="brand"
          v-for="(logo, i) in duplicatedLogos"
          :key="i"
        >
          <img :src="logo" alt="brand logo" />
        </div>
      </div>
    </div>

    <div class="fade right"></div>
  </div>
</template>


<script setup>
import { computed } from "vue"

import chanel from '@/assets/brandslogos/CHANEL.svg'
import coach from '@/assets/brandslogos/coach.svg'
import dior from '@/assets/brandslogos/Dior.svg'
import elf from '@/assets/brandslogos/elf.svg'
import givenchy from '@/assets/brandslogos/Givenchy.svg'
import glossier from '@/assets/brandslogos/Glossier.svg'
import gucci from '@/assets/brandslogos/Gucci.svg'
import gymshark from '@/assets/brandslogos/Gymshark.svg'
import hauslabs from '@/assets/brandslogos/Haus_Labs.svg'
import huda from '@/assets/brandslogos/huda.svg'
import kiko from '@/assets/brandslogos/kiko.svg'
import lululemon from '@/assets/brandslogos/Lululemon.svg'
import owala from '@/assets/brandslogos/owala.svg'
import pandora from '@/assets/brandslogos/Pandora.svg'
import patrick from '@/assets/brandslogos/PatrickTa.png'
import prada from '@/assets/brandslogos/Prada.svg'
//import rare from '@/assets/brandslogos/rare.avif'
import refy from '@/assets/brandslogos/refy.svg'
import rhode from '@/assets/brandslogos/Rhode.svg'
import saie from '@/assets/brandslogos/saie.png'
import skin1004 from '@/assets/brandslogos/skin1004.svg'
//import soldejaneiro from '@/assets/brandslogos/Pandora.svg'
//import summerfridays from '@/assets/brandslogos/Pandora.svg'
import swarovski from '@/assets/brandslogos/Swarovski.svg'
import target from '@/assets/brandslogos/Target.svg'
import tower from '@/assets/brandslogos/Tower_28_Beauty.svg'
import ulta from '@/assets/brandslogos/Ulta_Beauty.svg'
//import victorias from '@/assets/brandslogos/Ulta_Beauty.svg'

const logos = [
 chanel, coach, dior, elf, givenchy,glossier,gucci,gymshark, hauslabs, huda, kiko, lululemon, owala, pandora, patrick, prada, refy,rhode,saie, skin1004,swarovski,target,tower, ulta,

]

const duplicatedLogos = computed(() => [
  ...logos,
  ...logos
])
</script>


<style scoped>
.brand-wrapper {
  position: relative;
  width: 100%;
  overflow: hidden;
  background: #8dd7fc;
  padding: 10px 0;
}

.brand-bar {
  overflow: hidden;
}

.track {
  display: flex;
  width: max-content;
  animation: scroll 50s linear infinite;
}

.brand {
  margin: 0 40px;
  font-size: 13px;
  letter-spacing: 2px;
  color: #ffffff;
}

@keyframes scroll {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}

.fade {
  position: absolute;
  top: 0;
  width: 60px;
  height: 100%;
  z-index: 2;
}

.fade.left {
  left: 0;
  background: linear-gradient(to right, #fff, transparent);
}

.fade.right {
  right: 0;
  background: linear-gradient(to left, #fff, transparent);
}

.brand img {
  height: 20px;
  width: auto;
  object-fit: contain;
  opacity: 0.7;
  transition: all 0.3s ease;
}

/* hover bonito */
.brand img:hover {
  opacity: 1;
  transform: scale(1.05);
}

.brand img {
  filter: contrast(175%) brightness(3%);
}
</style>